import React, { useEffect, useRef, memo, useMemo } from 'react';
import Chart from 'chart.js';
import { sharedOptions } from 'helpers/chartHelpers';
import { isEqual } from 'lodash';
import './Graph.scss';
import colors from 'theme/Colors.module.scss';

const Graph = ({ dataSet, customOptions, tabOption }) => {
  const canvasRef = useRef(null);
  const chartInstance = useRef(null);

  // Memoize dataset generation
  const datasets = useMemo(() => {
    return dataSet.data.map(item => ({
      label: item.title,
      type: item.type,
      stack: item.stack,
      backgroundColor:
        tabOption.value === 'prints' ? colors.primary100 : colors.secondary100,
      hoverBackgroundColor:
        tabOption.value === 'prints' ? colors.primary900 : colors.secondary900,
      data: item.values,
    }));
  }, [dataSet.data, tabOption]);

  useEffect(() => {
    const ctx = canvasRef.current;
    if (!ctx) return;

    const width = ctx.parentElement.clientWidth;
    const height = ctx.parentElement.clientHeight;
    ctx.width = width;
    ctx.height = height;

    // Destroy previous instance
    if (chartInstance.current) chartInstance.current.destroy();

    chartInstance.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: dataSet.xLabels,
        datasets,
      },
      options: {
        ...sharedOptions,
        ...customOptions,
      },
    });

    return () => {
      chartInstance.current?.destroy();
    };
  }, [dataSet.xLabels, datasets, customOptions]);

  return <canvas id="dash-chart" height="420px" ref={canvasRef} />;
};

// Prevent re-renders unless props actually change
const areEqual = (prev, next) =>
  isEqual(prev.dataSet, next.dataSet) &&
  isEqual(prev.tabOption, next.tabOption);

export default memo(Graph, areEqual);
